/**
 * Localization messages for IncludedEntitlements component
 */
import sharedMessages from '../../../shared/messages/sharedMessages';
import { mergeInvertedMessages } from '../../../utils/localization';

const componentMessages = {
  // Row Content Helpers
  "{totalUsers} users meet this rule's criteria. {presentUserCount} currently have access to the entitlement.":
    'ruleRecs.includedEntitlements.rowContent.usersTooltip',
} as const;

const invertedMessages = mergeInvertedMessages(
  sharedMessages,
  componentMessages
);

export type IncludedEntitlementsMessage = keyof typeof invertedMessages;

export default invertedMessages;
